const hemData = [
  {
    start: 0,
    end: 25000,
    single: 1276,
    joint: 2520,
  },
  {
    start: 25001,
    end: 38000,
    single: 1357,
    joint: 2520,
  },
  {
    start: 38001,
    end: 51000,
    single: 1429,
    joint: 2593,
  },
  {
    start: 51001,
    end: 64000,
    single: 1529,
    joint: 2694,
  },
  {
    start: 64001,
    end: 76000,
    single: 1690,
    joint: 2856,
  },
  {
    start: 76001,
    end: 102000,
    single: 1964,
    joint: 3134,
  },
  {
    start: 102001,
    end: 127000,
    single: 2320,
    joint: 3494,
  },
  {
    start: 127001,
    end: 153000,
    single: 2617,
    joint: 3794,
  },
  {
    start: 153001,
    end: 178000,
    single: 2971,
    joint: 4152,
  },
  {
    start: 178001,
    end: 204000,
    single: 3164,
    joint: 4347,
  },
  {
    start: 204001,
    end: 254000,
    single: 3404,
    joint: 4591,
  },
  {
    start: 254001,
    end: 318000,
    single: 3883,
    joint: 5075,
  },
  {
    start: 318001,
    end: 382000,
    single: 4583,
    joint: 5783,
  },
  {
    start: 382001,
    end: 636000,
    single: 4762,
    joint: 5964,
  },
];

const HemSingleJoint = (totalIncome, numberOfApplicants) => {
  const dataIndex = hemData.findIndex(
    (p) => totalIncome >= p.start && totalIncome < p.end
  );

  if (dataIndex === -1) {
    return hemData[11].single;
  }

  switch (Number(numberOfApplicants)) {
    case 1:
      return hemData[dataIndex].single;
    case 2:
      return hemData[dataIndex].joint;
    default:
      return hemData[dataIndex].single;
  }
};

export default HemSingleJoint;
